import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from './../state.service';
import { AlertService } from './../alert.service';
import { ToastService } from './../toast.service';
import { urls } from "@app/env";
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';
@Injectable()
export class ApiAuthLicenseKeyService extends ApiBaseService {

  protected headers: Headers;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  /**
   * ライセンスキー認証
   * @param licenseKey string
   * @return void
   */
  post(licenseKey: string): Promise<any> {
    // ローディング表示する
    let loading = this.loadingCtrl.create({
      content: '認証中...'
    });
    loading.present();
    console.log(urls.api)
    // ライセンスキー認証用のAPIのみ、Configの設定から取得する。それ以外は、このAPIで返ってきたレスポンスのURLに対して実行する
    return new Promise((resolve) => {
      return this.doPost({
        url: urls.api + '/api/v1/auth/licensekey',
        body: {'licenseKey': licenseKey},
        headers: this.headers}
      ).finally(
        () => loading.dismiss()
      ).subscribe(
        response => resolve(response)
      )
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-auth-license-key.service.ts